import { ReactNode } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

interface LayoutProps {
  children: ReactNode;
  showNavbar?: boolean;
  showFooter?: boolean;
  className?: string;
}

export function Layout({
  children,
  showNavbar = true,
  showFooter = true,
  className = '',
}: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-gray-900">
      {showNavbar && <Navbar />}
      <main className={`flex-1 ${className}`}>{children}</main>
      {showFooter && <Footer />}
    </div>
  );
}
